import * as _ from 'lodash';
import { firevalveType } from '@brands-compart/form-wizard';
import { CrudModel } from '@ngx-ivengi/crud';
import { Channel } from '../channel/channel.model';
import { Product } from '../product/product.model';

export class Throughput extends CrudModel {

  public channelId: string;
  public channel: Channel;
  public status: string;
  public type: string;
  public subtype: string;
  public count: number = 1;
  public shape: string;
  public copyDimensionsFromChannel: boolean = false;
  public width: number;
  public height: number;
  public diameter: number;
  public removeFoam: boolean = false;
  public bundled: boolean;
  public firevalvePresent: boolean;
  public firevalvePlaced: boolean;
  public firevalveReplaced: boolean;
  public firevalveType: string;
  public firevalveExtension: boolean;
  public immure: boolean;
  public immureLength: number;
  public bend: boolean;
  public bendCount: number;
  public coating: boolean;
  public insulation: boolean;
  public insulationCorrect: boolean;
  public insulationType: string;
  public productGroup: string;
  public productId: string;
  public product: Product | string;
  public plateCount: number;
  public mountingsToPlace: number;
  public chargeInclude: boolean;
  public chargeUnit: string;
  public chargeAmount: number;
  public manualCalculation: boolean = false;
  public manualPrice?: number;
  public flutedPanelProfileType: number;
  public flutedPanelFillerType: string;
  public roofMaterial: string;
  public flameShieldFinish: string;
  public flameShieldThickness: number;
  public encaseBeam: boolean = false;
  public beamHeight: number;
  public numberOfBeams: number;
  public remarks: string;
  public dimension: string;
  public explanation: string;

  public setChannelId(channelId: string): this {
    if(typeof channelId === 'string') {
      this.channelId = channelId;
    }
    return this;
  }

  public setChannel(channel: Channel): this {
    if(channel instanceof Channel) {
      this.channel = channel;
    }
    return this;
  }

  public setStatus(status: string): this {
    if(typeof status === 'string') {
      this.status = status;
    }
    return this;
  }

  public setType(type: string): this {
    if(typeof type === 'string') {
      this.type = type;
    }
    return this;
  }

  public setSubtype(subtype: string): this {
    if(typeof subtype === 'string') {
      this.subtype = subtype;
    }
    return this;
  }

  public setCount(count: string | number): this {
    if(typeof count === 'string') {
      const int = parseInt(count, 10);
      if(!isNaN(int)) {
        this.count = int;
      }
    } else if (typeof count === 'number') {
      this.count = count;
    }
    return this;
  }

  public setShape(shape: string): this {
    if(typeof shape === 'string') {
      this.shape = shape;
    }
    return this;
  }

  public setCopyDimensionsFromChannel(copyDimensionsFromChannel: boolean): this {
    if(typeof copyDimensionsFromChannel === 'boolean') {
      this.copyDimensionsFromChannel = copyDimensionsFromChannel;
    }
    return this;
  }

  public setWidth(width: string | number): this {
    if(typeof width === 'string') {
      const int = parseInt(width, 10);
      if(!isNaN(int)) {
        this.width = int;
      }
    } else if (typeof width === 'number') {
      this.width = width;
    }
    return this;
  }

  public setHeight(height: string | number): this {
    if(typeof height === 'string') {
      const int = parseInt(height, 10);
      if(!isNaN(int)) {
        this.height = int;
      }
    } else if (typeof height === 'number') {
      this.height = height;
    }
    return this;
  }

  public setDiameter(diameter: string | number): this {
    if(typeof diameter === 'string') {
      const int = parseInt(diameter, 10);
      if(!isNaN(int)) {
        this.diameter = int;
      }
    } else if (typeof diameter === 'number') {
      this.diameter = diameter;
    }
    return this;
  }

  public setRemoveFoam(removeFoam: boolean): this {
    if(typeof removeFoam === 'boolean') {
      this.removeFoam = removeFoam;
    }
    return this;
  }

  public setBundled(bundled: boolean): this {
    if(typeof bundled === 'boolean') {
      this.bundled = bundled;
    }
    return this;
  }

  public setFirevalvePresent(firevalvePresent: boolean): this {
    if(typeof firevalvePresent === 'boolean') {
      this.firevalvePresent = firevalvePresent;
    }
    return this;
  }

  public setFirevalvePlaced(firevalvePlaced: boolean): this {
    if(typeof firevalvePlaced === 'boolean') {
      this.firevalvePlaced = firevalvePlaced;
    }
    return this;
  }

  public setFirevalveReplaced(firevalveReplaced: boolean): this {
    if(typeof firevalveReplaced === 'boolean') {
      this.firevalveReplaced = firevalveReplaced;
    }
    return this;
  }

  public setFirevalveType(type: string): this {
    if(typeof type === 'string') {
      this.firevalveType = type;
    } else {
      if (this.firevalvePlaced || this.firevalveReplaced) {
        this.firevalveType = firevalveType.FIREVALVE;
      }
    }
    return this;
  }

  public setFirevalveExtension(firevalveExtension: boolean): this {
    if(typeof firevalveExtension === 'boolean') {
      this.firevalveExtension = firevalveExtension;
    }
    return this;
  }

  public setImmure(immure: boolean): this {
    if(typeof immure === 'boolean') {
      this.immure = immure;
    }
    return this;
  }

  public setImmureLength(immureLength: string | number): this {
    if(typeof immureLength === 'string') {
      const int = parseInt(immureLength, 10);
      if(!isNaN(int)) {
        this.immureLength = int;
      }
    } else if (typeof immureLength === 'number') {
      this.immureLength = immureLength;
    }
    return this;
  }

  public setBend(bend: boolean): this {
    if(typeof bend === 'boolean') {
      this.bend = bend;
    }
    return this;
  }

  public setBendCount(bendCount: string | number): this {
    if(typeof bendCount === 'string') {
      const int = parseInt(bendCount, 10);
      if(!isNaN(int)) {
        this.bendCount = int;
      }
    } else if (typeof bendCount === 'number') {
      this.bendCount = bendCount;
    }
    return this;
  }

  public setMountingsToPlace(mountingsToPlace: number): this {
    if(typeof mountingsToPlace === 'number') {
      this.mountingsToPlace = mountingsToPlace;
    }
    return this;
  }

  public setCoating(coating: boolean): this {
    if (typeof coating === 'boolean') {
      this.coating = coating;
    }
    return this;
  }

  public setInsulation(insulation: boolean): this {
    if(typeof insulation === 'boolean') {
      this.insulation = insulation;
    }
    return this;
  }

  public setInsulationCorrect(insulactionCorrect: boolean): this {
    if(typeof insulactionCorrect === 'boolean') {
      this.insulationCorrect = insulactionCorrect;
    }
    return this;
  }

  public setInsulationType(insulationType: string): this {
    if(typeof insulationType === 'string') {
      this.insulationType = insulationType;
    }
    return this;
  }

  public setProductGroup(productGroup: string): this {
    if(typeof productGroup === 'string') {
      this.productGroup = productGroup;
    }
    return this;
  }

  public setProductId(productId: string): this {
    if(typeof productId === 'string') {
      this.productId = productId;
      if(!this.product) {
        this.product = productId;
      }
    }
    return this;
  }

  public setProduct(product: Product): this {
    if(product instanceof Product) {
      this.product = product;
    }
    return this;
  }

  public setPlateCount(plateCount: number): this {
    if(typeof plateCount === 'number') {
      this.plateCount = plateCount;
    }
    return this;
  }

  public setChargeInclude(chargeInclude: boolean): this {
    if(typeof chargeInclude === 'boolean') {
      this.chargeInclude = chargeInclude;
    }
    return this;
  }

  public setChargeUnit(chargeUnit: string): this {
    if(typeof chargeUnit === 'string') {
      this.chargeUnit = chargeUnit;
    }
    return this;
  }

  public setChargeAmount(chargeAmount: string | number): this {
    if(typeof chargeAmount === 'string') {
      const float = parseFloat(chargeAmount);
      if(!isNaN(float)) {
        this.chargeAmount = float;
      }
    } else if (typeof chargeAmount === 'number') {
      this.chargeAmount = chargeAmount;
    }
    return this;
  }

  public setRemarks(remarks: string): this {
    if(typeof remarks === 'string') {
      this.remarks = remarks;
    }
    return this;
  }

  public setDimension(dimension: string): this {
    if(typeof dimension === 'string') {
      this.dimension = dimension;
    }
    return this;
  }

  public setExplanation(explanation: string): this {
    if(typeof explanation === 'string') {
      this.explanation = explanation;
    }
    return this;
  }

  public setManualCalculation(manualCalculation: boolean): this {
    if(typeof manualCalculation === 'boolean') {
      this.manualCalculation = manualCalculation;
    }
    return this;
  }

  public setManualPrice(manualPrice: number): this {
    if(typeof manualPrice === 'number') {
      this.manualPrice = manualPrice;
    }
    return this;
  }

  public setFlutedPanelProfileType(flutedPanelProfileType: number): this {
    if(typeof flutedPanelProfileType === 'number') {
      this.flutedPanelProfileType = flutedPanelProfileType;
    }
    return this;
  }

  public setFlutedPanelFillerType(flutedPanelFillerType: string): this {
    if(typeof flutedPanelFillerType === 'string') {
      this.flutedPanelFillerType = flutedPanelFillerType;
    }
    return this;
  }

  public setRoofMaterial(roofMaterial: string): this {
    if (typeof roofMaterial === 'string') {
      this.roofMaterial = roofMaterial;
    }
    return this;
  }

  public setFlameShieldFinish(flameShieldFinish: string): this {
    if (typeof flameShieldFinish === 'string') {
      this.flameShieldFinish = flameShieldFinish;
    }
    return this;
  }

  public setFlameShieldThickness(flameShieldThickness: number): this {
    if (typeof flameShieldThickness === 'number') {
      this.flameShieldThickness = flameShieldThickness;
    }
    return this;
  }

  public setEncaseBeam(encaseBeam: boolean): this {
    if (typeof encaseBeam === 'boolean') {
      this.encaseBeam = encaseBeam;
    }
    return this;
  }

  public setBeamHeight(beamHeight: number): this {
    if (typeof beamHeight === 'number') {
      this.beamHeight = beamHeight;
    }
    return this;
  }

  public setNumberOfBeams(numberOfBeams: number): this {
    if (typeof numberOfBeams === 'number') {
      this.numberOfBeams = numberOfBeams;
    }
    return this;
  }


  public toRequest(): any {
    this
      .setCount(this.count)
      .setWidth(this.width)
      .setHeight(this.height)
      .setDiameter(this.diameter)
      .setImmureLength(this.immureLength)
      .setBendCount(this.bendCount)
      .setChargeAmount(this.chargeAmount)
      .setProductId(this.product as string);

    const request = _.cloneDeep(this);
    if (!request.productId) {
      delete request.productId;
    }

    return request;
  }

  public fromResponse(response: any): void {

    this
      .setId(response.id)
      .setChannelId(response.channelId)
      .setChannel(response.channel)
      .setStatus(response.status)
      .setType(response.type)
      .setSubtype(response.subtype)
      .setCount(response.count)
      .setShape(response.shape)
      .setCopyDimensionsFromChannel(response.copyDimensionsFromChannel)
      .setWidth(response.width)
      .setHeight(response.height)
      .setDiameter(response.diameter)
      .setRemoveFoam(response.removeFoam)
      .setBundled(response.bundled)
      .setFirevalvePresent(response.firevalvePresent)
      .setFirevalvePlaced(response.firevalvePlaced)
      .setFirevalveReplaced(response.firevalveReplaced)
      .setFirevalveType(response.firevalveType)
      .setFirevalveExtension(response.firevalveExtension)
      .setImmure(response.immure)
      .setImmureLength(response.immureLength)
      .setBend(response.bend)
      .setBendCount(response.bendCount)
      .setCoating(response.coating)
      .setInsulation(response.insulation)
      .setInsulationType(response.insulationType)
      .setInsulationCorrect(response.insulationCorrect)
      .setProductGroup(response.productGroup)
      .setProduct(response.product)
      .setProductId(response.productId)
      .setPlateCount(response.plateCount)
      .setChargeInclude(response.chargeInclude)
      .setChargeUnit(response.chargeUnit)
      .setChargeAmount(response.chargeAmount)
      .setRemarks(response.remarks)
      .setDimension(response.dimension)
      .setExplanation(response.explanation)
      .setManualCalculation(response.manualCalculation)
      .setManualPrice(response.manualPrice)
      .setFlutedPanelProfileType(response.flutedPanelProfileType)
      .setFlutedPanelFillerType(response.flutedPanelFillerType)
      .setRoofMaterial(response.roofMaterial)
      .setFlameShieldFinish(response.flameShieldFinish)
      .setFlameShieldThickness(response.flameShieldThickness)
      .setEncaseBeam(response.encaseBeam)
      .setBeamHeight(response.beamHeight)
      .setNumberOfBeams(response.numberOfBeams)
      .setMountingsToPlace(response.mountingsToPlace);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/throughput/throughput.model.ts